const MAX_STRING_LENGTH = 40;

export class TableField {
  key: string;
  label?: string;
  tdClass?: string | string[];
  thClass?: string | string[];
   thStyle?: Record<string, unknown>;
  sortable?: boolean;
  formatter?: any;
}

export function defaultDateTimeFormatter(dt: Date): string {
  return dt ? dt.toLocaleString() : "";
}
export function defaultDateFormatter(dt: Date): string {
  return dt ? dt.toLocaleDateString() : "";
}
export function defaultCurrencyFormatter(val: number): string {
  if (val)
    return val.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
  return "";
}
export function currencyFormatter4Digits(val: number): string {
  if (val)
    return val.toLocaleString("pt-br", { style: "currency", currency: "BRL", maximumFractionDigits: 4 });
  return "";
}
export function defaultTruncaTexto(val: string): string {
  return val.length < MAX_STRING_LENGTH
    ? val
    : val.substring(0, MAX_STRING_LENGTH - 1) + "...";
}
/**
 * Transforma uma boolean em 'Sim' ou 'Não'
 * @since 20230816
 */
export function defaultSimNaoBooleanFormatter(val: boolean): string {
  return val ? "Sim" : "Não";
}
/**
 * Transforma uma boolean em 'Cumpriu' ou 'Não cumpriu'
 * @since 20251017
 */
export function cumpriuNaoCumpriuBooleanFormatter(val: boolean): string {
  return val === true ? "Cumpriu" : "Não cumpriu";
}

export function defaultCPFFormatter(val: string): string {
  //original c
  //return val.replace(/[^\d]/g, "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  const badchars = /[^\d]/g;
  const mask = /(\d{3})(\d{3})(\d{3})(\d{2})/;
  const cpf = val.replace(badchars, "");
  return cpf.replace(mask, "$1.$2.$3-$4");
}
export function defaultCNPJFormatter(val: string): string {
  const badchars = /[^\d]/g;
  const mask = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/;
  const cnpj = val.replace(badchars, "");
  return cnpj.replace(mask, "$1.$2.$3/$4-$5");
}
export function defaultCpfCnpjFormatter(val: string): string {
  const digits = val.replace(/[^\d]/g, "");
  if (digits.length === 11) {
    return defaultCPFFormatter(digits);
  } else if (digits.length === 14) {
    return defaultCNPJFormatter(digits);
  }
  return val; // Retorna o valor original se não for CPF ou CNPJ válido
}
export function defaultInativoFormatter(val: string): string {
  return val === "S" ? "Inativo" : val === "N" ? "Ativo" : val;
}

export function nomeUgAbreviacaoFormatter(nomeUg: string): string {
  if (!nomeUg) return "";
  return nomeUg
    .replace(/prefeitura municipal de \s*/i, "PM ")
    .replace(/camara municipal de \s*/i, "CM ")
    .replace(/fundo municipal de assistencia social de \s*/i, "FMAS ")
    .replace(/fundo municipal de saude de \s*/i, "FMS ")
    .replace(/fundo municipal \s*/i, "FM ")
    .replace(/secretaria municipal \s*/i, "SECMUN ")
    ;
}

export function defaultPorcentagem2DigitosFormatter(val: number): string {
  if(val == null) return ''
  return `${(+val*100).toFixed(2)}%`
}

export function moedaOuHifenFormatter(valor?: number | null): string {
  if (valor === null || valor === undefined) return "-";
  return currencyFormatter4Digits(valor) || "-";
}

export function textoOuHifenFormatter(valor?: string | null): string {
  const texto = String(valor ?? "").trim();
  return texto || "-";
}
